import { useDialogStore } from '@ariakit/react/dialog'
import { useState } from 'react'
import { ProPhotosServiceCard } from '@/features/submission-pro-photos-upload/components/pro-photos-service-card'
import type {
	RemappedOfferingProPhotos,
	RemappedServiceProPhotos
} from '../types'
import { ServiceProPhotosChangeOfferingPhotoModal } from './service-pro-photos-change-offering-photo-modal'

interface ServicesProPhotosOfferingsProps {
	service: RemappedServiceProPhotos
}
export const ServicesProPhotosOfferings = ({
	service
}: ServicesProPhotosOfferingsProps) => {
	const changePhotoDialog = useDialogStore()
	const [selectedOffering, setSelectedOffering] =
		useState<RemappedOfferingProPhotos | null>(null)

	return (
		<>
			<div className='my-5 flex w-full flex-col gap-4'>
				{service.offerings.map((offering) => (
					<ProPhotosServiceCard
						coverImageUrl={offering.mainPhotoUrl}
						description={offering.questionAnswer.description.answer}
						key={offering.id}
						onCardClick={() => {
							setSelectedOffering(offering)
							changePhotoDialog.toggle()
						}}
						title={offering.questionAnswer.title.answer}
					/>
				))}
			</div>

			{selectedOffering !== null && (
				<ServiceProPhotosChangeOfferingPhotoModal
					galleryId={service.gallery.id}
					mainPhotoId={selectedOffering.imageId}
					offeringId={selectedOffering.id}
					offeringTitle={selectedOffering.questionAnswer.title.answer}
					onClose={() => {
						setSelectedOffering(null)
						changePhotoDialog.toggle()
					}}
					serviceId={service.id}
					store={changePhotoDialog}
				/>
			)}
		</>
	)
}
